import React, { Fragment } from 'react';
import RadioRhf from '../../components/ReactHookForm/RadioRhf/RadioRhf';
import { RadioOptionRhf } from '../../components/ReactHookForm/RadioRhf/RadioOptionRhf';
import MyTeethChoice from '../../components/ReactHookForm/TeethEquipmentRhf/MyTeethChoice';
import SDTeethRhf from '../../components/ReactHookForm/TeethEquipmentRhf/SDTeethRhf';
import CheckboxRhf from '../../components/ReactHookForm/CheckboxRhf/CheckboxRhf';
import CheckboxCardRhf from '../../components/ReactHookForm/CheckboxCardRhf/CheckboxCardRhf';
import { FormLabel, Grid, Radio, withStyles, Typography } from '@material-ui/core';
import { ErrorMessage } from '@hookform/error-message';
import TextFieldRhf from '../../components/ReactHookForm/TextFieldRhf/TextFieldRhf';
import { SelectRhf } from '../../components/ReactHookForm/SelectRhf/SelectRhf';
import MergedPreRestorativeAlignerRhf from '../../components/ReactHookForm/MergedPreRestorativeAlignerRhf/MergedPreRestorativeAlignerRhf';

const StyledRadio = withStyles({
    root: {
        color: '#445994',
        '&$disabled': {
            // keep disabled (unchecked) looking like normal unchecked
            color: 'rgba(0,0,0,0.54)',
            opacity: 1,
        },
        '&$checked': {
            // checked (enabled)
            color: '#445994',
        },
        '&$checked$disabled': {
            // checked + disabled should look like checked
            color: '#445994',
            opacity: 1,
        },
    },
    disabled: {},
    checked: {},
})(Radio);

const partialTranslation = (question, get, order) => {
    if (!question) return question;

    const cleanedText = question.startsWith('@') ? get(question).replace(/^\d+\.\s*/, '') : question;
    return order ? `${order}. ${cleanedText}` : cleanedText;
};

// Determines whether a conditional question should be visible for the current form values.
const shouldShowChild = (child, formValues) => {
    if (!child?.showWhen) return true;
    const { field, value: expectedValue, values: expectedValues, includesAny } = child.showWhen;
    if (includesAny) {
        return includesAny.some((expectedItem) => formValues?.[field]?.includes(expectedItem));
    }
    return expectedValues ? expectedValues.includes(formValues?.[field]) : formValues?.[field] === expectedValue;
};

// Renders Smile Design questions and their conditional children.
const loopSmileDesignQuestions = (smileDesignQuestions, formValues, readOnly = false, get = undefined, alwaysShowRequired = false, displayFirstFitFlag) => {
    return Object.keys(smileDesignQuestions).filter((key) => shouldShowChild(smileDesignQuestions[key], formValues)).map((key) => {
        const value = smileDesignQuestions[key];
        switch (value.component) {
            case 'RadioRhf':
                let radioComponent = !readOnly ? <Radio /> : <StyledRadio />;
                return (
                    <>
                        <RadioRhf
                            key={value.name}
                            question={partialTranslation(value.question, get, value?.notShowOrder ? false : key)}
                            name={value.name}
                            defaultValue={''}
                            alwaysShowRequired={alwaysShowRequired}
                            disabled={readOnly ? readOnly : value?.disable}
                            clearWhenDisabled={!readOnly && value?.disable}
                            formControlLabelRhf={
                                <>
                                    {
                                        value.name === 'verticalDimension' ? (
                                            <div style={{ marginLeft: 10, marginTop: 5 }}>
                                                <Typography style={{ color: readOnly ? '#000000' : undefined, paddingBottom: 4, fontSize: 15 }}>
                                                    {partialTranslation(value.remark, get, false)}
                                                </Typography>
                                                <img
                                                    src={`/img/SDTeeth/SD7.jpg`}
                                                    width={430}
                                                    style={{
                                                        height: 'auto',
                                                        maxWidth: '100%',
                                                        aspectRatio: '16/5.5',
                                                        objectFit: 'cover',
                                                        borderRadius: 8,
                                                    }}
                                                    alt={`teeth-7`}
                                                />
                                            </div>

                                        ) : null
                                    }
                                    <Grid container  direction={value.direction ? value.direction : 'row'} justifyContent="flex-start" alignItems="flex-start">
                                        {value.option.map((v) => (
                                            <RadioOptionRhf
                                                key={v.value}
                                                value={v.value}
                                                style={v.paddingBottom ? { paddingBottom: `${v.paddingBottom}px` } : undefined}
                                                label={
                                                    (
                                                        displayFirstFitFlag ? 
                                                        <Typography
                                                            style={{
                                                                position: 'relative',
                                                                minWidth: v?.width ? `${v.width}px` : 'auto',
                                                                color: value?.disable || v.disable ? 'rgba(0, 0, 0, 0.38)' : undefined,
                                                            }}
                                                        >
                                                            {partialTranslation(v.label, get, false)}
                                                            {v?.desc && (
                                                                <span
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '30px',
                                                                        left: '-30px',
                                                                        display: 'block',
                                                                        color: '#6B6B76',
                                                                        fontSize: 13,
                                                                        fontWeight: 400,
                                                                        lineHeight: 1.1,
                                                                    }}
                                                                >
                                                                    {partialTranslation(v.desc, get, false)}
                                                                </span>
                                                            )}
                                                        </Typography>
                                                    :<Typography
                                                        style={{
                                                            color: readOnly
                                                                ? '#000000'
                                                                : value?.disable || v.disable
                                                                    ? 'rgba(0, 0, 0, 0.38)'
                                                                    : undefined,
                                                        }}
                                                    >
                                                        {partialTranslation(v.label, get, false)}
                                                    </Typography>
                                                    )
                                                    
                                                }
                                                disable={readOnly ? readOnly : value?.disable || v.disable}
                                                children={
                                                    v?.children &&
                                                    loopSmileDesignQuestions(v?.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag)
                                                }
                                                radio={radioComponent}
                                            />
                                        ))}
                                    </Grid>
                                </>
                            }
                            ImageComponent={value?.imageComponent}
                            resetFieldObject={value?.resetFieldObject}
                            revalidateObject={value?.revalidateObject}
                        />
                        {
                            value.remark &&
                            !(displayFirstFitFlag && value.name === 'verticalDimension') &&
                            (!value.remarkWhen || formValues?.[value.name] === value.remarkWhen) && (
                                <Typography
                                    style={{
                                        marginTop: '6px',
                                        color: '#6B6B76',
                                        fontSize: 14,
                                        fontStyle: 'italic',
                                        whiteSpace: 'pre-wrap',
                                        ...(value.remark.includes('verticalDimensionPosteriorRemark')
                                            ? { fontFamily: 'Montserrat, sans-serif' }
                                            : {}),
                                    }}
                                >
                                    {partialTranslation(
                                        value.remark,
                                        get,
                                        false
                                    )}
                                </Typography>
                            )
                        }
                        <div style={{ marginBottom: 20 }}></div>
                        {value?.children &&
                            (() => {
                                const children = value.children;
                                if (Array.isArray(children)) {
                                    const filtered = children.filter((child) => shouldShowChild(child, formValues));
                                    if (filtered.length === 0) return null;
                                    return loopSmileDesignQuestions(filtered, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag);
                                }
                                return loopSmileDesignQuestions(children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag);
                            })()}
                    </>
                );
            case 'MyTeethChoice':
                return (
                    <>
                        <MyTeethChoice
                            key={value.name}
                            question={partialTranslation(value.question, get, value?.notShowOrder ? false : key)}
                            name={value.name}
                            teethSelectionDisabled={readOnly}
                            optional={value.optional}
                            alwaysShowRequired={value.alwaysShowRequired}
                            checkSuccess={value.checkSuccess}
                            quickTeethOption={value.quickTeethOption}
                            imageScale={
                                [
                                    '@PatientInfo.smileDesign.prescriptionNotes.question.selectTeethNotChangeFirstFit',
                                    '@PatientInfo.smileDesign.prescriptionNotes.question.selectTeethSimulationFirstFit',
                                    '@PatientInfo.smileDesign.prescriptionNotes.question.selectTeethSimulation',
                                ].includes(value.question)
                                    ? 0.9
                                    : 1
                            }
                        />
                        <div style={{ marginBottom: 20 }}></div>
                        {value?.children && loopSmileDesignQuestions(value?.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag)}
                    </>
                );
            case 'SDTeethRhf':
                return (
                    <>
                        <div style={{ fontSize: 16, fontWeight: 600, color: 'black' }}>
                            {partialTranslation(
                                '@PatientInfo.smileDesign.prescriptionNotes.question.chooseDentalMorphology',
                                get,
                                false
                            )}
                        </div>
                        <div style={{ marginBottom: 12 }}>
                            <ErrorMessage
                                name={value.name}
                                render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                            />
                        </div>
                        <SDTeethRhf
                            key={value.name}
                            name={value.name}
                            disable={readOnly ? readOnly : value?.disable}
                            showSingleError={value.showSingleError}
                            formValues={formValues}
                            displayFirstFitFlag={displayFirstFitFlag}
                        />
                        <div style={{ marginBottom: 40 }}></div>
                        {value?.children && loopSmileDesignQuestions(value?.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag)}
                    </>
                );
            case 'CheckboxRhf':
                return (
                    <>
                        <FormLabel component="legend">
                            {partialTranslation(value.question, get, value?.notShowOrder ? false : key)}
                            {value.alwaysShowRequired && <span style={{ color: 'red', marginLeft: 8 }}>*</span>}
                        </FormLabel>
                        {value.option.map((v) => {
                            return (
                                <Fragment key={v.value}>
                                    <CheckboxRhf
                                        key={v.value}
                                        label={partialTranslation(v.label, get, value?.notShowOrder ? false : key)}
                                        name={value.name}
                                        checkBoxValue={v.value}
                                        disable={readOnly ? readOnly : v.disable}
                                        defaultValue={[]}
                                        question={false}
                                        showSingleError={value.showSingleError}
                                    />
                                    {v?.children && loopSmileDesignQuestions(v?.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag)}
                                </Fragment>
                            );
                        })}
                        {value.showBottomError !== false && (
                            <div style={{ marginLeft: 8 }}>
                                <ErrorMessage
                                    name={value.name}
                                    render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                                />
                            </div>
                        )}
                        <div style={{ marginBottom: 20 }}></div>
                        {value?.children && loopSmileDesignQuestions(value?.children, formValues, readOnly, get, alwaysShowRequired , displayFirstFitFlag)}
                    </>
                );
            case 'CheckboxCardRhf':
                return (
                    <>
                        <FormLabel component="legend">
                            {partialTranslation(value.question, get, value?.notShowOrder ? false : key)}
                            {value.alwaysShowRequired && !(readOnly && value.hideRequiredInReadOnly) && (
                                <span style={{ color: 'red', marginLeft: 8 }}>*</span>
                            )}
                        </FormLabel>
                        <div className="restorative-card-grid" style={{ marginTop: 8, marginLeft: 8, maxWidth: '600px'  }}>
                            {value.option.map((option) => (
                                <CheckboxCardRhf
                                    key={option.value}
                                    label={partialTranslation(option.label, get, false)}
                                    name={value.name}
                                    value={option.value}
                                    disabled={readOnly ? readOnly : option.disable}
                                    readOnly={readOnly}
                                />
                            ))}
                        </div>
                        {value.showBottomError !== false && (
                            <div style={{ marginLeft: 8 }}>
                                <ErrorMessage
                                    name={value.name}
                                    render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                                />
                            </div>
                        )}
                        <div style={{ marginBottom: 20 }}></div>
                        {value?.children && loopSmileDesignQuestions(value?.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag)}
                    </>
                );
            case 'TextFieldRhf': {
                return (
                    <>
                        <div key={value.name} style={{ marginBottom: 20 }}>
                            <TextFieldRhf
                                name={value.name}
                                question={partialTranslation(value.question, get, key)}
                                multiline
                                readOnly={readOnly}
                            />
                        </div>
                        {value?.children && loopSmileDesignQuestions(value?.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag    )}
                    </>
                );
            }

            case 'QuestionTwoGroupOptionRhf': {
                // Apply the compact layout only to the Q4 jaw selectors.
                const isVerticalDimensionPosterior = value.name === 'verticalDimensionPosterior';
                return (
                    <div style={isVerticalDimensionPosterior ? { marginBottom: 16 } : undefined}>
                        <FormLabel component="legend">{partialTranslation(value.question, get, key)}</FormLabel>
                        {value?.children &&
                            (value.direction ? (
                                <Grid
                                    container
                                    direction={value.direction}
                                    alignItems="flex-start"
                                    style={isVerticalDimensionPosterior ? { marginTop: -20 } : undefined}
                                >
                                    {loopSmileDesignQuestions(value.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag)}
                                </Grid>
                            ) : (
                                loopSmileDesignQuestions(value.children, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag)
                            ))}
                        {value.showError && (
                            <ErrorMessage
                                name={value.name}
                                render={({ message }) => (
                                    <div
                                        style={{
                                            color: 'red',
                                            paddingLeft: 10,
                                            marginLeft: isVerticalDimensionPosterior ? 0 : 50,
                                            marginTop: isVerticalDimensionPosterior ? 8 : 0,
                                        }}
                                    >
                                        {message}
                                    </div>
                                )}
                            />
                        )}
                    </div>
                );
            }

            case 'SelectRhf': {
                if(displayFirstFitFlag){
                    const selectLabel = value.label ? partialTranslation(value.label, get, false) : '';
                    const isVerticalDimensionPosterior =
                        value.name === 'verticalDimensionUpperPosterior' || value.name === 'verticalDimensionLowerPosterior';
                    const isUpperVerticalDimensionPosterior = value.name === 'verticalDimensionUpperPosterior';

                    if (readOnly) {
                        const valueDisplay = formValues[value.name] || value.defaultValue;
                        return (
                            <div
                                style={{
                                    marginBottom: isVerticalDimensionPosterior ? 0 : 8,
                                    marginLeft: isUpperVerticalDimensionPosterior ? 0 : 50,
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {selectLabel && (
                                    <h4 style={{ margin: 0, marginRight: 30, whiteSpace: 'nowrap' }}>{selectLabel}</h4>
                                )}
                                <Typography>{valueDisplay}</Typography>
                            </div>
                        );
                    }
                    return (
                        <div
                            id={`Q.${value.name}`}
                            style={{
                                marginBottom: isVerticalDimensionPosterior ? 0 : 8,
                                marginLeft: isUpperVerticalDimensionPosterior ? 10 : 50,
                                marginTop: isVerticalDimensionPosterior ? 10 : 0,
                                display: 'flex',
                                alignItems: isVerticalDimensionPosterior ? '' : 'center',
                                flexDirection: isVerticalDimensionPosterior ? 'column' : 'row',
                            }}
                        >
                            {selectLabel && (
                                <h4 style={{ margin: 0, marginRight: 30, whiteSpace: 'nowrap', marginBottom: isVerticalDimensionPosterior ? 8 : 0 }}>{selectLabel}</h4>
                            )}
                            <SelectRhf
                                option={value.option}
                                name={value.name}
                                label={selectLabel}
                                defaultValue={value.defaultValue}
                                disabled={readOnly}
                            />
                            {value?.children && loopSmileDesignQuestions(value?.children, formValues, readOnly, get, alwaysShowRequired,displayFirstFitFlag)}
                        </div>
                    );
                }else{
                    const selectLabel = value.label ? partialTranslation(value.label, get, false) : '';
                    if (readOnly) {
                        const valueDisplay = formValues[value.name] || value.defaultValue;
                        return (
                            <div style={{ marginBottom: 8, marginLeft: 50, display: 'flex', alignItems: 'center' }}>
                                {selectLabel && (
                                    <h4 style={{ margin: 0, marginRight: 30, whiteSpace: 'nowrap' }}>{selectLabel}</h4>
                                )}
                                <Typography>{valueDisplay}</Typography>
                            </div>
                        );
                    }
                    return (
                        <div
                            id={`Q.${value.name}`}
                            style={{ marginBottom: 8, marginLeft: 50, display: 'flex', alignItems: 'center' }}
                        >
                            {selectLabel && (
                                <h4 style={{ margin: 0, marginRight: 30, whiteSpace: 'nowrap' }}>{selectLabel}</h4>
                            )}
                            <SelectRhf
                                option={value.option}
                                name={value.name}
                                label={selectLabel}
                                defaultValue={value.defaultValue}
                                disabled={readOnly}
                            />
                            {value?.children && loopSmileDesignQuestions(value?.children, formValues, readOnly, get)}
                        </div>
                    );
                }
                
            }
            case 'MergedPreRestorativeAlignerRhf':
                return (
                    <>
                        <MergedPreRestorativeAlignerRhf
                            key={value.name}
                            question={partialTranslation(value.question, get, value?.notShowOrder ? false : key)}
                            readOnly={readOnly}
                            alwaysShowRequired={alwaysShowRequired}
                        />
                        <div style={{ marginBottom: 20 }}></div>
                        {value?.children &&
                            (() => {
                                const children = value.children;
                                if (Array.isArray(children)) {
                                    const filtered = children.filter((child) => shouldShowChild(child, formValues));
                                    if (filtered.length === 0) return null;
                                    return loopSmileDesignQuestions(filtered, formValues, readOnly, get, alwaysShowRequired, displayFirstFitFlag);
                                }
                                return loopSmileDesignQuestions(children, formValues, readOnly, get, alwaysShowRequired);
                            })()}
                    </>
                );
            default:
                return null;
        }
    });
};

export default loopSmileDesignQuestions;
